import { CheckCircleIcon, ArrowPathIcon, BanknotesIcon } from "@heroicons/react/24/outline"
import { money } from "../../../../../utility/Helper1"

const WithdrawalSummary = ({ withdrawals = [] }) => {
  // Calculate summary statistics
  const totalAmount = withdrawals.reduce((sum, item) => sum + Number.parseFloat(item.readOnlyTotalWithdrawn || 0), 0)
  const pendingCount = withdrawals.filter((item) => item.status == 0).length
  const completedCount = withdrawals.filter((item) => item.status == 1).length

  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6">
      <h3 className="text-lg font-medium text-gray-800 mb-4">Withdrawal Summary</h3>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div className="bg-green-50 rounded-lg p-4 flex items-center">
          <div className="rounded-full bg-green-100 p-2 mr-3">
            <BanknotesIcon className="h-6 w-6 text-green-600" />
          </div>
          <div>
            <p className="text-sm text-gray-600">Total Withdrawn</p>
            <p className="text-xl font-bold text-gray-800">{money(totalAmount)}</p>
          </div>
        </div>

        <div className="bg-blue-50 rounded-lg p-4 flex items-center">
          <div className="rounded-full bg-blue-100 p-2 mr-3">
            <CheckCircleIcon className="h-6 w-6 text-blue-600" />
          </div>
          <div>
            <p className="text-sm text-gray-600">Completed</p>
            <p className="text-xl font-bold text-gray-800">{completedCount}</p>
          </div>
        </div>

        <div className="bg-yellow-50 rounded-lg p-4 flex items-center">
          <div className="rounded-full bg-yellow-100 p-2 mr-3">
            <ArrowPathIcon className="h-6 w-6 text-yellow-600" />
          </div>
          <div>
            <p className="text-sm text-gray-600">Pending</p>
            <p className="text-xl font-bold text-gray-800">{pendingCount}</p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default WithdrawalSummary
